import {css, Theme} from "@emotion/react";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {InputRange, IRange} from "@pg-design/inputs-module";
import {form, IFormProps} from "@pg-mono/form";
import {Round} from "@pg-mono/formik-utils";

import {SearchFilterLabel} from "../../search/components/filters/SearchFilterLabel";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";

interface IProps extends IFormProps<ISearchFiltersFormValues> {}

const AreaFilterC = (props: IProps) => {
    const areaProps = props.getFieldProps("area");

    return (
        <div css={[inputContainer, areaInput]}>
            <SearchFilterLabel label="Powierzchnia mieszkania (m²)" htmlFor="area_lower" />
            <InputRange
                {...props}
                hasDashSeparator
                roundToMultiplicationOf={Round.AREA}
                errorOnBottom
                {...areaProps}
                onChange={(name, value) => {
                    areaProps.onChange(name, value as IRange<string>);
                }}
            />
        </div>
    );
};

export const AreaFilter = form<ISearchFiltersFormValues, IProps>(AreaFilterC);

const areaInput = css`
    width: 100%;

    > div {
        ${w100};
    }

    > div *:not(span):not(input) {
        ${w100};
    }
`;

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    flex-direction: column;

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;
import {css, Theme} from "@emotion/react";

import {flex, mb, w100} from "@pg-design/helpers-css";
import {InputRange, IRange} from "@pg-design/inputs-module";
import {form, IFormProps} from "@pg-mono/form";
import {Round} from "@pg-mono/formik-utils";

import {SearchFilterLabel} from "../../search/components/filters/SearchFilterLabel";
import {ISearchFiltersFormValues} from "../reducers/property_configurator_reducer";

interface IProps extends IFormProps<ISearchFiltersFormValues> {}

const AreaFilterC = (props: IProps) => {
    const areaProps = props.getFieldProps("area");

    return (
        <div css={[inputContainer, areaInput]}>
            <SearchFilterLabel label="Powierzchnia mieszkania (m²)" htmlFor="area_lower" />
            <InputRange
                {...props}
                hasDashSeparator
                roundToMultiplicationOf={Round.AREA}
                errorOnBottom
                {...areaProps}
                onChange={(name, value) => {
                    areaProps.onChange(name, value as IRange<string>);
                }}
            />
        </div>
    );
};

export const AreaFilter = form<ISearchFiltersFormValues, IProps>(AreaFilterC);

const areaInput = css`
    width: 100%;

    > div {
        ${w100};
    }

    > div *:not(span):not(input) {
        ${w100};
    }
`;

const inputContainer = (theme: Theme) => css`
    ${flex("flex-start")};
    flex-direction: column;

    > label > p {
        ${mb(1)};
        color: ${theme.colors.gray[700]};
    }
`;
